const reducer = (state, action) => {
    const actions = {
        SET_COLOR: { ...state, color: action.payload },
        SET_FORMAT: { ...state, format: action.payload },
        RANDOM_COMBO: {
            ...state,
            color: action.payload.color,
            format: action.payload.format
        }
    }
    return actions[action.type]
}

export default reducer